// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__jYvuu","tab":"ProcedureTabs_tab__J1Hb7"};